module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h10"
  }, [_c('a', {
    attrs: {
      "id": "a42"
    }
  }), _vm._v("Prologue")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("Water.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("The oars of the great barge gently lap the Euphrates, keeping time to the ripples of the peacock-colored sails and the hands of the multitudes who line the banks, waving palm fronds in a shimmering mirage of heat and dust.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("Their rhythm is the beating butterfly of my own heart, which must soar as my body no longer can.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("All life began in the water, Aristotle always liked to remind me. How fitting, then, that mine should end there.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("Twice daily, I am borne across the river—an act that, unbeknown to the other players, is a precursor to that day when Charon will row me to the far Stygian shore, and I shall return no more.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("Until then I rest by Babylon’s famed mountain-garden with its pools of lofty cattails and pink lotuses, symbols of resurrection.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("Attended by my ever-solicitous eunuch, Bagoas, and my even-more solicitous queen, Roxane, I preside over prayers offered by suspicious priests in a language that is not my own to gods I respect but do not worship.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("I am a long way from the place I once called home.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("Yet here I am home, ruler of an imperial mosaic of peoples for whom I am conqueror, stranger, father, fiend, legend, god.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("I am a man become a myth.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("Once that myth could set the fates of thousands in motion with the mere turn of my head. Now, lightly clothed in the colors of the sea on a white and gold litter that my bodyguards carry everywhere, I can barely speak or gesture to those who shake their heads and murmur about the beautiful, young, still-living corpse.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("Instead, I tell my story to myself—as if I were writing it or dictating it to my secretary Eumenes of Cardia, or my other diarist, Diodotus of Erythrae. It helps me pretend that I’m still alive. It keeps me from going mad like Ajax at Troy.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("Mostly, though, I drift on a current of sleep and memory. In dreams, he comes to me, an armored figure of a man as splendid as the sun. In his right hand, he holds out a sword; in his left, a handful of dust—the sands of lands I have conquered, the bones of men I have crushed.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("The warrior—Achilles, for I know it is he—smiles at me, then flings the dust in my face. At which I wake from my dream and find no one there, except my beloved, who stirs beside me and smiles, his blue eyes dancing beneath dark curls. Raising himself on one elbow, he grabs the back of my damp neck. My coarse blond hair itches at the nape.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("“They cannot hurt you anymore,” Hephaestion whispers. “I’ve got you now.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("As if to prove it, he places a hand on the cool, hard curve of my naked spine. The hand cups my buttocks and trails across my groin until it finds the sought-after treasure.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("Lying side by side—his gaze fixed on my eyes, one the color of mulled wine in firelight; the other, of a stormy sea—we mirror each other’s movements until we fall asleep, sated once more and, for the moment, at peace.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("Then I wake in earnest and realize that my beloved is—as I will soon be—dead.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05107d20","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005.vue
// module id = 66
// module chunks = 0